import { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { NotificationBox } from '@eneco/sparky';

import { NextButton } from '../../components/NextButton/NextButton';
import type { FlowNotificationContent } from '../../types/content';

interface Props {
  /** Shown under the options when the answer lets the flow go on but needs a word of warning. */
  nonBlockingNotification?: FlowNotificationContent;
  /** Shown in place of the next button when the answer stops the flow. */
  blockingNotification?: FlowNotificationContent;
  isNonBlockingShown: boolean;
  isBlocked: boolean;
  nextStepText?: string;
  isLoading: boolean;
}

/**
 * How a choice step ends: the notification for an answer the flow goes on with, then the next button, or,
 * for an answer that stops the flow, its notification in the button's place.
 */
export const ChoiceStepFooter: FC<Props> = ({
  nonBlockingNotification,
  blockingNotification,
  isNonBlockingShown,
  isBlocked,
  nextStepText,
  isLoading,
}) => (
  <>
    {isNonBlockingShown && (
      <NotificationBox
        isAlert={false}
        variant={nonBlockingNotification?.variant}
        title={nonBlockingNotification?.title}
        text={<RichText html={nonBlockingNotification?.content} />}
      />
    )}
    {isBlocked ? (
      <NotificationBox
        isAlert={false}
        variant={blockingNotification?.variant}
        title={blockingNotification?.title}
        text={<RichText html={blockingNotification?.content} />}
      />
    ) : (
      <NextButton isLoading={isLoading}>{nextStepText}</NextButton>
    )}
  </>
);
